import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const mutation = gql`
    mutation CreateBulkReward($sourceId: String!, $amount: Int!, $currency: String!, $businessId: String!, $emails: [String!]!) {
        createBulkReward(sourceId: $sourceId, amount: $amount, currency: $currency, emails: $emails, businessId: $businessId) {
            uuid
            status
        }
    }
`

export const createBulkRewardKey = getQueryNames(mutation)[0]

export default mutation
